// Presentation only: calculation values and chart geometry remain authoritative.
export const PHASE_COLORS = [
  'var(--carbon-400)', 'var(--carbon-500)', 'var(--carbon-700)',
  'var(--carbon-800)', 'var(--status-info)', 'var(--green-dark)',
];